<template>
    <div>
        <!--底部-->
        <ul class="footer">
            <router-link tag="li" to="/" @click.native="clickHome">
                <img src="~@public/img/newIndex/icon_dh_01.png" alt="首页" v-if="isHome1"/>
                <img src="~@public/img/newIndex/icon_dh_09.png" alt="首页" v-if="isHome">
                <p>首页</p>
            </router-link>
            <router-link tag="li" to="" @click.native="clickMatter(true,'/matterList')">
                <img src="~@public/img/newIndex/icon_dh_02.png" alt="办事" v-if="isMatter1"/>
                <img src="~@public/img/newIndex/icon_dh_06.png" alt="办事" v-if="isMatter"/>
                <p>办事</p>
            </router-link>
            <router-link tag="li" to="#" @click.native="link" class="service-box">
                <img src="~@public/img/newIndex/icon_dh_03.png" alt="客服"/>
            </router-link>
            <router-link tag="li" to="/hotApply" @click.native="clickAdv">
                <img src="~@public/img/newIndex/icon_dh_04.png" alt="便民" v-if="isAdv1"/>
                <img src="~@public/img/newIndex/icon_dh_07.png" alt="便民" v-if="isAdv"/>
                <p>便民</p>
            </router-link>
            <router-link tag="li" to="/userCenter" @click.native="clickUse">
                <img src="~@public/img/newIndex/icon_dh_05.png" alt="我的" v-if="isUse1"/>
                <img src="~@public/img/newIndex/icon_dh_08.png" alt="我的" v-if="isUse"/>
                <p>我的</p>
            </router-link>
        </ul>
    </div>
</template>

<script>
  export default {
    name: "Floor",
    data() {
      return {
        isHome: false,
        isMatter: false,
        isAdv: false,
        isUse: false,
        isHome1: true,
        isMatter1: true,
        isAdv1: true,
        isUse1: true,
      }
    },
    mounted() {
      this.brightFooter(this.$route.path)
    },
    watch: {
      $route(to, from) {
        this.brightFooter(to.path)
      }
    },
    methods: {
      /**
       * 足部高亮
       */
      brightFooter(path) {
        if (path === '/') {
          // 首页
          this.clickHome()
        } else if (path.indexOf('/matterList') !== -1) {
          // 办事
          this.clickMatter(false, '')
        } else if (path === '/advisoryList') {
          // 便民
          this.clickAdv()
        } else if (path === '/userCenter') {
          // 个人中心
          this.clickUse()
        } else {
          this.clickHome()
        }
      },
      link() {
        // 用户登录
        if (this.$cookie.loginState()) {
          window.location.href = 'https://wsgaj.chutianyun.gov.cn/robot/#/robot/' + this.$cookie.getUser().guid;
        } else {
          window.location.href = 'https://wsgaj.chutianyun.gov.cn/robot/#/robot/null';
        }

      },
      clickHome() {
        this.isHome = false;
        this.isHome1 = true;
        this.isMatter = false;
        this.isMatter1 = true;
        this.isAdv = false;
        this.isAdv1 = true;
        this.isUse = false;
        this.isUse1 = true;

      },
      clickMatter(toUrl, path) {
        this.isHome = true;
        this.isHome1 = false;
        this.isMatter = true;
        this.isMatter1 = false;
        this.isAdv = false;
        this.isAdv1 = true;
        this.isUse = false;
        this.isUse1 = true;
        // 点击进入事项列表且当前路由不是事项列表的时候添加标识
        if (toUrl && this.$route.path.indexOf('/matterList') === -1) {
          window.sessionStorage.setItem('matterJump', 'Y')
          this.$router.push(path)
        }
      },
      clickAdv() {
        this.isHome = true;
        this.isHome1 = false;
        this.isMatter = false;
        this.isMatter1 = true;
        this.isAdv = true;
        this.isAdv1 = false;
        this.isUse = false;
        this.isUse1 = true;
      },
      clickUse() {
        this.isHome = true;
        this.isHome1 = false;
        this.isMatter = false;
        this.isMatter1 = true;
        this.isAdv = false;
        this.isAdv1 = true;
        this.isUse = true;
        this.isUse1 = false;
      }
    }
  }
</script>

<style lang="less" scoped>
    .footer {
        display: flex;
        justify-content: space-between;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 1.3rem;
        padding: 0 .24rem;
        box-shadow: 0 -.06rem .06rem 0 rgba(29, 42, 91, 0.06);
        background: #fff;

        li {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 1.2rem;
            height: 100%;
            background: #fff;
            font-size: .25rem;
            text-align: center;
            padding: 3px 0;
            color: black;
        }

        img {
            vertical-align: middle;
            height: .46rem;
            margin: .12rem 0 .05rem;
        }

        p {
            font-size: .32rem;
        }

        .service-box {
            display: flex;
            align-items: center;
            vertical-align: middle;
            width: 1.2rem;
            height: 1.2rem;
            margin-top: -.3rem;
            background: #F3F3F3;
            border-radius: 50%;

            img {
                height: .8rem;
            }
        }
    }
</style>
